import type { MemberNotification } from "../api/notification-contract";

export function shouldDisplayNotificationPopup(
  notification: Pick<MemberNotification, "id"> | null | undefined,
) {
  return Boolean(notification);
}
